import { createSvgIcon } from '@mui/material';

export const CheckFilledIcon = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
    <path
      fill="currentColor"
      d="m8.833 13.833 5.875-5.875-1.166-1.166L8.833 11.5 6.458 9.125l-1.166 1.167 3.541 3.541Zm1.167 4.5a8.115 8.115 0 0 1-3.25-.656 8.416 8.416 0 0 1-2.646-1.781 8.415 8.415 0 0 1-1.781-2.646A8.115 8.115 0 0 1 1.667 10c0-1.153.218-2.236.656-3.25a8.415 8.415 0 0 1 1.781-2.646A8.415 8.415 0 0 1 6.75 2.323 8.115 8.115 0 0 1 10 1.667c1.153 0 2.236.218 3.25.656a8.415 8.415 0 0 1 2.646 1.781 8.416 8.416 0 0 1 1.781 2.646 8.115 8.115 0 0 1 .656 3.25 8.115 8.115 0 0 1-.656 3.25 8.415 8.415 0 0 1-1.781 2.646 8.415 8.415 0 0 1-2.646 1.781 8.115 8.115 0 0 1-3.25.656Z"
    />
  </svg>,
  'CheckFilledIcon',
);
